<template>
  <div>
    <NoteReminder
      class="border px-4 py-3"
      :class="{ 'border-b-0': deals.length }"
      :note="note"
      :contact="contact"
    />
    <div v-if="linkedDeal" class="border border-t-0">
      <DealShort :deal="linkedDeal" subtle class="border-t border-gray-200 text-sm text-gray-500" />
    </div>
    <div v-else-if="deals.length" class="relative" v-on-clickaway="hide">
      <button
        class="px-4 flex text-sm text-blue-500 bg-blue-100 py-3 w-full relative border border-t-0 border-blue-200"
        @click="isOpen = !isOpen"
        @keydown.esc="hide"
      >Deze notitie aan een deal koppelen?</button>
      <div class="absolute w-full bg-white shadow-lg inset-x-0 z-10 border mt-1" v-if="isOpen">
        <button
          v-for="deal in deals"
          :key="deal.id"
          @click="linkToDeal(deal)"
          class="block w-full text-left hover:bg-gray-100"
        >
          <DealShort :deal="deal" no-tooltips />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin as clickaway } from "vue-clickaway";
import NoteReminder from "./NoteReminder";
import DealShort from "./DealShort";
import { patch } from "@/api";

export default {
  mixins: [clickaway],

  props: {
    note: {
      type: Object,
      required: true
    },
    contact: {
      type: Object,
      required: true
    }
  },

  components: {
    NoteReminder,
    DealShort
  },

  data() {
    return {
      isOpen: false
    };
  },

  computed: {
    deals() {
      return this.contact.deals;
    },

    linkedDeal() {
      return this.contact.deals.find(deal => deal.id === this.note.deal_id);
    }
  },

  methods: {
    hide() {
      this.isOpen = false;
    },

    linkToDeal(deal) {
      patch(`/contacts/${this.contact.id}/notes/${this.note.id}/deal`, {
        deal_id: deal.id
      }).then(response => this.$store.commit("SET_CONTACT", response.data));

      this.hide();
    }
  }
};
</script>